import {authHeader2} from '../helpers/authHeader';
import axios from 'axios';

const { REACT_APP_SERVER_URL } = process.env;

const request = axios.create({
  baseURL: REACT_APP_SERVER_URL,
});

const filesRequest = axios.create({
  baseURL: REACT_APP_SERVER_URL,
});

const loginRequest = axios.create({
  baseURL: REACT_APP_SERVER_URL,
});


request.interceptors.request.use (
  function (config) {
    return authHeader2().then(auths => {
      config.headers.Authorization = auths.token;
      config.headers["okta-token"] = auths.oktaToken;
      /*const okta = JSON.parse(localStorage.getItem('okta-token-storage')||'{}');
      config.headers.Authorization = auth;
      config.headers["okta-token"] = 'Bearer '+okta.accessToken.accessToken;*/
      return config;
    }).catch(error => {
      return Promise.reject(error);
    });
  },
  function (error) {
    return Promise.reject(error);
  }
);

/*request.interceptors.request.use (
  function (config) {
    return authHeader().then(auth => {
      config.headers.Authorization = auth;
      return config;
    }).catch(error => {
      return Promise.reject(error);
    });
  },
  function (error) {
    return Promise.reject(error);
  }
);*/

filesRequest.interceptors.request.use(
  function (config) {
    return authHeader2().then(auths => {
      config.headers.Authorization = auths.token;
      config.headers["okta-token"] = auths.oktaToken;
      return config;
    }).catch(error => {
      return Promise.reject(error);
    });
  },
  function (error) {
    return Promise.reject(error);
  }
);

loginRequest.interceptors.request.use(
  function(config) {
    const okta = JSON.parse(localStorage.getItem('okta-token-storage')||'{}');
    if ('accessToken' in okta.accessToken) {
      config.headers["okta-token"] = 'Bearer '+okta.accessToken.accessToken;
      return config;
    }
    return Promise.reject({ response: { data: { error: { message: "Okta token not valid" }}}});
  },
  function (error) {
    return Promise.reject(error);
  }
)

export function handleError(error, failure) {  
  // TODO handle errors
}

export function handleResponse(response) {
  // deal with API response
  return response.data;
}

export { request, filesRequest, loginRequest };